import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsTableModule } from '@lcs/shared/table';
import { LcsTableFooterModule } from '@lcs/shared/table-footer';
import { AutoTitleDirective } from '../column-layouts/auto-title-directive/auto-title.directive';
import { TitleIfOverflowDirective } from '../column-layouts/auto-title-directive/title-overflow.directive';
import { AutoRegisterColumnDefDirective } from './column-definitions/auto-register-column-def.directive';
import { ActionsColumnDefComponent } from './column-definitions/row-actions/actions-column-def.component';
import { RegisterCreateOptionsComponent } from './create-options/register-create-options.component';
import { RegisterQuickFilterComponent } from './quick-filter/register-quick-filter.component';
import { SortDirective } from './sort-columns/sort.directive';
import { CompactRegisterTwoColumnViewComponent } from './views/compact-register-view-two-column.component';
import { CompactRegisterViewComponent } from './views/compact-register-view.component';
import { RegisterViewComponent } from './views/register-view.component';
import { TitleIfTruncatedDirective } from '../column-layouts/auto-title-directive/truncated-title.directive';

@NgModule({
   declarations: [
      RegisterViewComponent,
      RegisterQuickFilterComponent,
      RegisterCreateOptionsComponent,
      CompactRegisterViewComponent,
      CompactRegisterTwoColumnViewComponent,
      ActionsColumnDefComponent,
      AutoRegisterColumnDefDirective,
      SortDirective,
      AutoTitleDirective,
      TitleIfOverflowDirective,
      TitleIfTruncatedDirective
   ],
   exports: [
      RegisterViewComponent,
      RegisterQuickFilterComponent,
      RegisterCreateOptionsComponent,
      CompactRegisterViewComponent,
      CompactRegisterTwoColumnViewComponent,
      ActionsColumnDefComponent,
      AutoRegisterColumnDefDirective,
      SortDirective,
      AutoTitleDirective,
      TitleIfOverflowDirective,
      TitleIfTruncatedDirective
   ],
   imports: [
      CommonModule,
      FormsModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatButtonModule,
      MatFormFieldModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatChipsModule,
      ScrollingModule,
      LcsTableModule,
      LcsTableFooterModule,
   ],
})
export class RegisterModule {}
